// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"94a4221bcead0f1af215","678":"7285f863107a2445b7e0","883":"b779b3ab1910c142ce6b"}[chunkId] + ".js";
};